import { PlayNetworkIcon } from './PlayNetworkIcon';

/**
 * author: Michael Richins
 * id 5B10237B-B7AA-4B35-B8C0-C97747F1E3E7
 * name play-network
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/play-network.svg
 * tags
 */
export const MediaNetworkIcon = PlayNetworkIcon;
export default MediaNetworkIcon